export const PageHeading = ({ title, description }) => {
  return (
    <div className="mb-6 border-y border-gray-200 p-4 px-10">
      <div className="max-w-6xl">
        <h2 className="text-xl font-semibold">{title}</h2>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </div>
  )
}
